import { Component, createRef } from "react"
import PropTypes from "prop-types"
import ClickOutside from "react-click-outside"
import classnames from "classnames"

import colors from "foundation/_colors_export.scss?export"
import AdminOnlyLabel from "partners/components/admin_only_label"
import ImportService from "partners/components/import_service"

import {
  ServiceListElement,
  orgShape,
  serviceShape,
} from "./selector_components"

export default class ServiceSelectMenu extends Component {
  state = {
    open: false,
  }

  importServiceRef = createRef()

  handleImportClick = e => {
    e.preventDefault()
    this.setState({ open: false })
    this.importServiceRef.current.pickFile()
  }

  toggleOpen = e => {
    e.preventDefault()
    e.stopPropagation()
    this.setState({ open: !this.state.open })
  }

  // Re-rendering on every outside click resets the import modal's controlled checkboxes mid-click.
  onClickOutside = () => {
    if (this.state.open) this.setState({ open: false })
  }

  renderServiceMenuItems() {
    const { activeOrg, currentService } = this.props

    const serviceHasAnOrg = activeOrg.services.some(
      s => s.module_name === currentService.module_name
    )
    const menuServices = serviceHasAnOrg ? activeOrg.services : [currentService]

    if (this.state.open) {
      return [
        ...menuServices.map((service, index) => (
          <ServiceListElement
            key={index}
            service={service}
            shouldRenderChevron={serviceHasAnOrg && index === 0}
            menuIsOpen={this.state.open}
            toggleOpen={this.toggleOpen}
            handleMenuClick={this.handleServiceMenuItemClick}
          />
        )),
        serviceHasAnOrg && (
          <li className="add-item" key={activeOrg.services.length}>
            <a
              onClick={e => {
                e.preventDefault()
                // Are they holding command and wanting to open this in a new tab? Let 'em.
                if (e.metaKey) {
                  return window.open(e.target.href, "_blank")
                }
                window.location.assign(e.target.href)
              }}
              href={`/services/new?org_id=${this.props.activeOrg.id}`}
              title={`Add a new Service to the ${this.props.activeOrg.name} Organization`}
            >
              + Add Service
            </a>
          </li>
        ),
        serviceHasAnOrg && this.props.isAdmin && (
          <li className="add-item" key={`import-${activeOrg.id}`}>
            <a
              onClick={this.handleImportClick}
              href="#"
              title={`Import a Service from JSON into the ${this.props.activeOrg.name} Organization`}
            >
              + Import Service <AdminOnlyLabel />
            </a>
          </li>
        ),

      ]
    } else if (currentService && currentService.organization) {
      return (
        <ServiceListElement
          service={currentService}
          shouldRenderChevron
          isMakerService={false}
          menuIsOpen={this.state.open}
          toggleOpen={this.toggleOpen}
          handleMenuClick={this.handleServiceMenuItemClick}
        />
      )
    }
  }

  handleServiceMenuItemClick = service => {
    if (this.state.open) {
      if (this.props.currentService.module_name === service.module_name) {
        return this.setState({ open: false })
      }
      return window.location.assign(service.url)
    }
    this.setState({ open: true })
  }

  getColor(org) {
    if (org.color_hsl === "#000") {
      return colors.primaryTextColor
    }
    return org.color_hsl
  }

  render() {
    let navClass = classnames("service-dropdown", {
      "services-open": this.state.open,
    })
    return (
      <>
        <ClickOutside onClickOutside={this.onClickOutside}>
          <nav className={navClass}>
            <ul
              className="service-list"
              style={{ backgroundColor: this.getColor(this.props.activeOrg) }}
            >
              {this.renderServiceMenuItems()}
            </ul>
          </nav>
        </ClickOutside>
        {this.props.isAdmin && (
          <ImportService
            ref={this.importServiceRef}
            organizationId={this.props.activeOrg.id}
            organizationName={this.props.activeOrg.name}
            importPlanUri={this.props.importPlanUri}
            importUri={this.props.importUri}
          />
        )}
      </>
    )
  }
}

ServiceSelectMenu.propTypes = {
  activeOrg: orgShape,
  currentService: serviceShape,
  currentOrganization: orgShape,
  otherId: PropTypes.number,
  baseURI: PropTypes.string,
  makerURI: PropTypes.string,
  importPlanUri: PropTypes.string,
  importUri: PropTypes.string,
  isAdmin: PropTypes.bool,
}
